/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { TimeZonePicker } from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = () => {
  const [selectedTimeZone, setSelectedTimeZone] =
    useState<string>('Europe/Stockholm');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <TimeZonePicker
        label="Small"
        value={selectedTimeZone}
        onChange={setSelectedTimeZone}
        size="small"
        htmlAttributes={{ id: 'time-zone-input-small' }}
      />
      <TimeZonePicker
        label="Medium (default)"
        value={selectedTimeZone}
        onChange={setSelectedTimeZone}
        size="medium"
        htmlAttributes={{ id: 'time-zone-input-medium' }}
      />
      <TimeZonePicker
        label="Large"
        value={selectedTimeZone}
        onChange={setSelectedTimeZone}
        size="large"
        htmlAttributes={{ id: 'time-zone-input-large' }}
      />
    </div>
  );
};

export default Component;
